var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26698(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26698",
    "data-name": "Group 26698",
    transform: "translate(-976 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(976 788)",
    fill: "#1ab3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23256",
    "data-name": "Path 23256",
    d: "M716.69,79.527a12.569,12.569,0,0,1-3.191,8.486,21.083,21.083,0,0,0-3.827,6.7c0,.021-.007.038-.009.058h-11.74c0-.02-.007-.039-.009-.058a21.082,21.082,0,0,0-3.826-6.7,12.877,12.877,0,1,1,22.6-8.486m-11.725-6.9a1.172,1.172,0,0,0-1.172-1.172,8.16,8.16,0,0,0-8.207,8.141,1.176,1.176,0,0,0,1.172,1.172,1.191,1.191,0,0,0,1.172-1.237,5.855,5.855,0,0,1,5.862-5.8,1.12,1.12,0,0,0,1.172-1.107m-7.035,24.49h11.725l-.009,2.873a2.754,2.754,0,0,1-.392,1.3L708,103.166a2.621,2.621,0,0,1-1.95,1.046h-4.519a2.621,2.621,0,0,1-1.952-1.046l-1.256-1.883a2.337,2.337,0,0,1-.387-1.3Z",
    transform: "translate(308.104 738.304)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26698);
export default __webpack_public_path__ + "static/media/Group 26698.abd75e6677806bbfba6f561eb4fbd178.svg";
export { ForwardRef as ReactComponent };